<template>
    <div class="leftNav">
        <el-menu default-active="1-4-1" class="el-menu-vertical-demo">
            <el-menu-item index="1">
                <i class="icon iconfont icon-fufei"></i>
                <span slot="title">收银</span>
            </el-menu-item>
            <el-menu-item index="2">
                <i class="icon iconfont icon-shouye"></i>
                <span slot="title">店铺</span>
            </el-menu-item>
            <el-menu-item index="3">
                <i class="icon iconfont icon-yingyangke"></i>
                <span slot="title">商品</span>
            </el-menu-item>
            <el-menu-item index="4">
                <i class="icon iconfont icon-huangguan"></i>
                <span slot="title">会员</span>
            </el-menu-item>
            <el-menu-item index="5">
                <i class="icon iconfont icon-zhongjinshu"></i>
                <span slot="title">统计</span>
            </el-menu-item>
            <el-menu-item index="6">
                <i class="icon iconfont icon-chufang"></i>
                <span slot="title">设置</span>
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    }
}
</script>

<style>
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/leftNav.vue